import classes from "../Kiosk_viennaPlzen_redesign.module.css";
import back from "../../../../store/Vienna_new/65506-200.png";
import room
    from "../../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Big Meeting Space - Classroom - 1550191.jpg";
import suproom
    from "../../../../store/Vienna_new/planek_v7_bez_Stinu_e.png";
import {React, useEffect, useState} from "react";
import Record from "./Record";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";

const Meet = (props) => {

    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [cards, setCards] = useState([])
    const [group, setGroup] = useState(19)
    const [datalist, setDataList] = useState([])
    const [opalA, setOpalA] = useState([])
    const [opalB, setOpalB] = useState([])
    const [opalC, setOpalC] = useState([])
    const [opalD, setOpalD] = useState([])
    const [safir, setSafir] = useState([])
    const [topaz, setTopaz] = useState([])
    const [smaragd, setSmaragd] = useState([])
    const setObje = (x) => {
        let fld = []
        for (let i = 0; i < x.length; i++) {
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const fetchDayList = async (gr) => {
        setOpalA([])
        setOpalB([])
        setOpalC([])
        setOpalD([])
        setSafir([])
        setTopaz([])
        setSmaragd([])
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        try {
            const response = await axios.get(`${path}/getDayRecordsV2?day=${date}&id=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setDataList(response.data);
            for (let i = 0; i < response.data.length; i++) {
                switch (response.data[i].description) {
                    case "OPAL A": {
                        setOpalA(response.data[i].path);
                        break;
                    }
                    case "OPAL B": {
                        console.log(response.data[i].path);
                        setOpalB(response.data[i].path);
                        break;
                    }
                    case "OPAL C": {
                        setOpalC(response.data[i].path);
                        break;
                    }
                    case "OPAL D": {
                        setOpalD(response.data[i].path);
                        break;
                    }
                    case "SAFIR": {
                        setSafir(response.data[i].path);
                        break;
                    }
                    case "SMARAGD": {
                        setSmaragd(response.data[i].path);
                        break;
                    }
                    case "TOPAZ": {
                        setTopaz(response.data[i].path);
                        break;
                    }

                }
            }
            //setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }

    const fetchDataCards = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&group=${gr}&onlyVisible=1`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            props.reset();
        }, 2* 60* 1000); // spustí se po 10 vteřinách

        return () => {
            clearTimeout(timer); // vyčisti timeout při unmountu
        };
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % cards.length);
        }, 15000);
        return () => {
            clearInterval(intervalId);
        };
    }, [cards]);
    useEffect(() => {
        //console.warn("ajojda")
        fetchDataCards(19)
        fetchDayList()
    }, [])

    return <>
        <div className={classes.slideshowMenu}>
            <div className={classes.menuBackbt} onClick={() => {
                props.setStep(0)
            }}>
                <img src={back}/>
            </div>
            <div className={classes.menuLine}>
                <div
                    className={`${classes.buttonCirc} ${classes.sleepBTsubmenu} `} onClick={() => {
                    props.setStep(1)
                }}>Sleep
                </div>
                <div
                    className={`${classes.buttonCirc} ${classes.eatBTsubmenu} `} onClick={() => {
                    props.setStep(2)
                }}>Eat
                </div>
                <div
                    className={`${classes.buttonCirc} ${classes.meetBTsubmenu} ${classes.activebt}`}>Meet
                </div>
                <div
                    className={`${classes.buttonCirc} ${classes.exploreBTsubmenu}`} onClick={() => {
                    props.setStep(4)
                }}>Explore
                </div>
            </div>
            {cards.length > 0 && <img src={cards[currentIndexA].Body.imgURL}/>}
            {cards.length == 0 && <img src={room}/>}

        </div>
        <div className={classes.sleepBody}>
            <div className={classes.sleepHeader}>Meetings and Events</div>
            <div className={classes.meetTxt}>
                <div className={classes.headMeet}>
                    <div className={classes.meetdate}>DATE</div>
                    <div className={classes.meetdate}>FROM</div>
                    <div className={classes.meetdate}>TO</div>
                    <div className={classes.meetdate}>COMPANY</div>
                    <div className={classes.meetdate}>HALL</div>
                </div>
                <div className={classes.meetbody}>
                    {datalist.length > 0 && datalist.map((x) => {
                        return <Record data={x} key={x.recordID}/>
                    })}

                </div>
            </div>
            <div className={classes.meetingPic}>
                <img src={suproom}/>
                {opalA.length > 0 && <div className={classes.opalA}><img src={`${path}/admin/${opalA}`}/></div>}
                {opalB.length > 0 && <div className={classes.opalB}><img src={`${path}/admin/${opalB}`}/></div>}
                {opalC.length > 0 && <div className={classes.opalC}><img src={`${path}/admin/${opalC}`}/></div>}
                {opalD.length > 0 && <div className={classes.opalD}><img src={`${path}/admin/${opalD}`}/></div>}
                {safir.length > 0 && <div className={classes.safir}><img src={`${path}/admin/${safir}`}/></div>}
                {topaz.length > 0 && <div className={classes.topaz}><img src={`${path}/admin/${topaz}`}/></div>}
                {smaragd.length > 0 && <div className={classes.smaragd}><img src={`${path}/admin/${smaragd}`}/></div>}
            </div>
        </div>
    </>
}
export default Meet;